const refundStatus = {
    'pending': 'Aguarda aprovação',
    'approved': 'Aprovado',
    'rejected': 'Não aprovado'
}

export default refundStatus
